import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Timeline } from "primereact/timeline";
import { Button } from "primereact/button";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Image } from "primereact/image";
import { useLocation, useNavigate } from "react-router-dom"; // Import useLocation
import "./TimelineDemo.css"; // Đảm bảo rằng CSS của bạn được nhập đúng
import ModalDv from "./ModalLocation";
import { generatePdf } from "./generatePdf";
// import AddLocationPopup from './AddLocationPopup';
import { colorIntersection } from "../../constants/color";
import { formatDate } from "./ModalShowPlan";

import {
    getTeamProgress,
    resetTeamProgress,
    resetTeamChildren,
    getDViFull,
} from "../../store/order/slice";
import { formatDate2 } from "../../components/utils";

import "../../assets/scss/theme-base/Intersection.css";
import ModalAssignment2 from "./ModalAssignment2";
import { getOrder } from "../../store/order/slice";
import FormatDate from "../Report/FormatDate";
import IntersectionChildren from "./intersectionChildren";

// Custom hook để lấy các tham số từ URL
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const Locate1 = (visible) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const query = useQuery();
    const factoryCode = query.get("factoryCode") || ""; // Lấy factoryCode từ URL
    const [loading, setLoading] = useState(true);
    const [visibleModalDv, setVisibleModalDv] = useState(false);
    const [selectedEventName, setSelectedEventName] = useState("");
    const [visibleAddLocationPopup, setVisibleAddLocationPopup] =
        useState(false);
    const [showAssignmentModal, setShowAssignmentModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [teamGroupId, setTeamGroupId] = useState("");
    const [intersection1Modal, setOpenIntersection1Modal] = useState(false);
    console.log("teamGroupId", teamGroupId);

    const {
        dataTeamProgress,
        events,
        teamChildrenData,
        dataDVi,
        orderData,
        productData,
    } = useSelector(
        (state) => ({
            dataTeamProgress: state.Production.dataTeamProgress,
            events: state.Production.dataTeamProgress?.data?.items,
            teamChildrenData: state.Production.teamChildrenData,
            dataDVi: state.Production.dataDVi,
            orderData: state.Production.orderData,
            productData: state.Production.dataTeamProgress?.data?.productData,
        }),
        shallowEqual
    );

    useEffect(() => {
        dispatch(
            getOrder({
                page: 1,
                limit: orderData?.data?.products?.totalItems,
                current: "plan",
            })
        );
    }, [dispatch, orderData?.data?.products?.totalItems]);

    useEffect(() => {
        setSelectedItem(
            orderData?.data?.products?.items.find(
                (item) => item.factoryCode === factoryCode
            )
        );
    }, [orderData?.data?.products?.items, factoryCode]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await dispatch(getTeamProgress({ id: factoryCode }));

            setLoading(false);
        };
        fetchData();
    }, [dispatch, factoryCode]);

    const customizedContent = (item) => {
        // const handleDetailClick = (eventName) => {
        //     setSelectedEventName(eventName);
        //     setVisibleModalDv(true);
        // };
        const handleDetailClick = (item) => {
            // setSelectedEventName(eventName);
            // setVisibleModalDv(true);

            setOpenIntersection1Modal(true);
            setTeamGroupId(item.teamId);
        };
        return (
            <Card
                title={
                    <div
                        style={{
                            backgroundColor: item?.Productions[0]?.status
                                ? colorIntersection.find(
                                      (color) =>
                                          color.index ===
                                          item?.Productions[0]?.index
                                  )?.color
                                : "transparent",
                            color: item?.Productions[0]?.status ? "white" : "",
                            width: "fit-content",
                            padding: "2px 8px",
                            borderRadius: "3px",
                        }}
                    >
                        {item.name}
                    </div>
                }
            >
                {item.Productions.map((production, index) => {
                    const timeStart = production.timeStart;
                    const timeEnd = production.timeEnd;

                    return (
                        <div
                            key={index}
                            className="flex align-items-center justify-content-between"
                        >
                            <div style={{ width: "400px" }}>
                                {item.name !== "Tiếp nhận đơn hàng" && (
                                    <div className="flex pb-3 align-items-center">
                                        <p>
                                            Kế hoạch hoàn thành:{" "}
                                            {formatDate(production?.startDate)}{" "}
                                            - {formatDate(production?.endDate)}
                                        </p>
                                        {production?.status && (
                                            <span
                                                style={{
                                                    padding: "2px",
                                                    backgroundColor:
                                                        production?.status ===
                                                        "Trễ tiến độ"
                                                            ? "red"
                                                            : "#ffd966",
                                                    color: "white",
                                                    borderRadius: "3px",
                                                    marginLeft: "2px",
                                                }}
                                            >
                                                {production?.status}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <p>
                                    {item === events[events.length - 1]
                                        ? `Thời gian bắt đầu: ${formatDate2(
                                              timeStart
                                          )}`
                                        : `Thời gian: ${
                                              timeEnd
                                                  ? `${formatDate2(
                                                        timeStart
                                                    )} - ${formatDate2(
                                                        timeEnd
                                                    )}`
                                                  : `${formatDate2(
                                                        timeStart
                                                    )} ${
                                                        timeStart
                                                            ? "- đang làm"
                                                            : ""
                                                    }`
                                          }`}
                                </p>
                                <p className="pt-3">
                                    Số lượng:{" "}
                                    {parseInt(item.totalEnd) !== 0
                                        ? item.totalEnd
                                        : item.totalStart}
                                </p>

                                <p className="mt-2">{production.note}</p>
                            </div>
                            <div>
                                {production.images && (
                                    <div className="image-container pt-3">
                                        {production.images.map(
                                            (image, imgIndex) => (
                                                <Image
                                                    key={imgIndex}
                                                    src={image}
                                                    height="50"
                                                    width="50"
                                                    alt={item.name}
                                                    preview
                                                />
                                            )
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
                {item !== events[events?.length - 1] && (
                    <Button
                        label="Xem tổ đội"
                        className="p-button-text"
                        onClick={() => handleDetailClick(item)}
                    ></Button>
                )}
            </Card>
        );
    };

    const handleModalDvHide = () => {
        setVisibleModalDv(false);
        dispatch(resetTeamChildren());
    };

    const customizedMarker = (item) => {
        return (
            <span
                className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1"
                style={{ backgroundColor: "green" }}
            >
                <i className={item.icon}></i>
            </span>
        );
    };

    const handleAddLocationClick = () => {
        setVisibleAddLocationPopup(true);
    };

    const reversedEvents = Array.isArray(events) ? [...events] : [];

    const token = localStorage.getItem("accessToken");
    const title = (color) => {
        if (color) {
            if (color === "#ff0000") {
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            padding: "4px 8px",
                            borderRadius: "5px",
                        }}
                    >
                        Trễ tiến độ
                    </div>
                );
            }
            if (color === "#ff5050") {
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            padding: "4px 8px",
                            borderRadius: "5px",
                        }}
                    >
                        Đúng ngày giao
                    </div>
                );
            }
            if (color === "#ffff00") {
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            padding: "4px 8px",
                            borderRadius: "5px",
                        }}
                    >
                        Gần giao dưới 3 ngày
                    </div>
                );
            }
            if (color === "#ffd966") {
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            padding: "4px 8px",
                            borderRadius: "5px",
                        }}
                    >
                        Gần giao dưới 1 tuần
                    </div>
                );
            }
        } else {
            return "";
        }
    };

    return (
        <>
            <Dialog
                visible={visible}
                onHide={() => {
                    dispatch(resetTeamProgress());
                    navigate("/import");
                }}
                footer={
                    // <div className='flex justify-content-between'>
                    //   <Button
                    //     label='Thêm định vị'
                    //     type='button'
                    //     onClick={handleAddLocationClick}
                    //   />
                    // </div>
                    <Button
                        label="Phân công sản xuất"
                        onClick={() => setShowAssignmentModal(true)}
                    />
                }
                className="responsive-dialog"
                header={
                    <div className="flex align-items-center justify-content-center text-2xl">
                        DỰ ÁN: {productData?.Building?.name}
                    </div>
                }
                modal
                style={{ width: "48%", height: "90%" }}
            >
                <>
                    <div className="text-xl font-semibold ml-8">
                        <div>Tên hạng mục: {productData?.categoryName}</div>
                        <div className="mt-2">
                            Mã nhà máy: {productData?.factoryCode}
                        </div>
                        <div className="flex align-items-center mt-2">
                            Kế hoạch hoàn thành:{" "}
                            {FormatDate(productData?.intendFinishDate)}{" "}
                            <span className="ml-2">
                                {title(productData?.color)}
                            </span>
                        </div>
                    </div>
                    <div className="card">
                        <Timeline
                            value={reversedEvents}
                            align="alternate"
                            className="customized-timeline"
                            marker={customizedMarker}
                            content={customizedContent}
                        />
                    </div>
                </>
                {visibleModalDv && (
                    <ModalDv
                        visible={visibleModalDv}
                        onHide={handleModalDvHide}
                        factoryCode={factoryCode}
                        name={selectedEventName}
                    />
                )}
            </Dialog>
            {/* {visibleAddLocationPopup && (
        <AddLocationPopup
          factoryCode={factoryCode}
          visible={visibleAddLocationPopup}
          onHide={() => setVisibleAddLocationPopup(false)}
        />
      )} */}
            <ModalAssignment2
                isShow={showAssignmentModal}
                onHide={() => setShowAssignmentModal(false)}
                factoryCode={factoryCode}
            />
            <IntersectionChildren
                visible={intersection1Modal}
                onHide={() => setOpenIntersection1Modal(false)}
                teamGroupId={teamGroupId}
                factoryCode={productData?.factoryCode}
                rowData={productData}
                productId={productData?.id}
                isHideEdit={true}
            />
        </>
    );
};

export default Locate1;
